define('home/mixins/asNotificationCard',[
    'jquery',
    'underscore',

    'core/utils',
    'core/analytics/jester',

    'home/utils/navigationUtils',
    'home/mixins/withAllstarPopover',
], function (
    $,
    _,

    utils,
    jester,

    NavigationUtils,
    withAllstarPopover
) {
    'use strict';

    var urlFragmentReg = /#.*$/;

    var asNotificationCard = {
        className: 'card-wrap card--notification',

        initialize: function (_initialize, options) {
            _initialize.call(this, options);

            this.listenTo(this.model, 'change:isUnread', this.updateUnreadClass);
            this.updateUnreadClass();
        },

        updateUnreadClass: function () {
            this.$el.toggleClass('unread', Boolean(this.model.get('isUnread')));
        },

        serializeData: function (_serializeData) {
            var data = _serializeData.apply(this, arguments);

            return _.defaults(data, {
                discussionRoute: this.model.thread && this.model.thread.getDiscussionRoute(),
            });
        },

        // Tracking functionality
        trackView: function () {
            if (this.model.get('isUnread'))
                jester.client.emit(this.getAnalyticsPayload('view'));
        },

        trackClick: function (evt) {
            var $elem = $(evt.currentTarget);

            // First check if we should handle this event at all.
            if (!this.shouldTrackClick(evt, $elem))
                return;

            var trackXhr = jester.client.emit(this.getAnalyticsPayload('click'));

            // If an event is going to open a new tab or window, we don't need to
            // do anything else at this point. Otherwise we need to make sure all the
            // handlers' deferred objects have a chance to resolve before we allow
            // navigation.
            // TODO: Look into [sendBeacon](https://developer.mozilla.org/en-US/docs/Web/API/Navigator/sendBeacon)
            if (trackXhr && this.shouldDelayNavigation(evt, $elem)) {
                evt.preventDefault();
                evt.stopPropagation();

                var navigate = _.once(function () {
                    // Make sure to set the 'top' location in case we are iFramed
                    window.top.location = $elem[0].href;
                });

                // navigate if deferreds don't complete within timeout
                _.delay(navigate, 1000);
                trackXhr.always(navigate);
            }
        },

        shouldTrackClick: function (evt, $elem) {
            // We don't do anything if we're already handling this event elsewhere.
            if (evt.isDefaultPrevented())
                return false;

            // We don't bother if the clicked link doesn't have an href attribute,
            // or if the clicked link's href attribute is just a hash.
            var href = ($elem.attr('href') || '').replace(urlFragmentReg, '');

            return Boolean(href);
        },

        shouldDelayNavigation: function (evt, $elem) {
            // If Home's navigation utils will capture the link click or
            // the link is being opened in a new window, we don't need to
            // delay the click.
            return !(NavigationUtils.isInbound(evt.target) || utils.willOpenNewWindow(evt, $elem));
        },
    };

    return function () {
        withAllstarPopover.call(this);

        this.className = _.wrap(this.className, function (_className) {
            if (_.isFunction(_className))
                _className = _className.call(this);
            _className = _className || '';

            return asNotificationCard.className + ' ' + _className;
        });

        this.initialize = _.wrap(this.initialize, asNotificationCard.initialize);

        this.serializeData = _.wrap(this.serializeData, asNotificationCard.serializeData);

        // Iff this view has defined getAnalyticsPayload then mix in tracking functionality
        if (this.getAnalyticsPayload) {
            _.extend(this, _.pick(asNotificationCard, [
                'trackView',
                'trackClick',
                'shouldTrackClick',
                'shouldDelayNavigation',
            ]));

            this.events = _.extend({
                'click a': 'trackClick',
            }, this.events);

            this.onRender = _.wrap(this.onRender, function (_onRender) {
                if (_onRender)
                    _onRender.call(this);

                this.trackView();
            });
        }

        _.extend(this, _.pick(asNotificationCard, [
            'updateUnreadClass',
        ]));
    };
});

